import { Mortgage } from '@/app/mortgage/entities/mortgage.entity'

export interface MortgageState {
    mortgages: Mortgage[]
}

export const state: MortgageState = {
    mortgages: []
}
